import { TextInput } from 'alkali'

export const TEXT_INPUT_CHANGE_EVENTS = [
	'change',
	'propertychange',
	'click',
	'keyup',
	'input',
	'paste',
	'blur',
]

const TextInputControl = TextInput('.form-control', {
	inputEvents: TEXT_INPUT_CHANGE_EVENTS,
})

TextInputControl.CHANGE_EVENTS = TEXT_INPUT_CHANGE_EVENTS

export default TextInputControl
